import React from 'react';
import { useI18n } from '../i18n/useI18n';

export function DesktopOnlyNotice({ title, description }) {
  const { t } = useI18n();
  return (
    <section className="panel desktopOnlyNotice">
      <span className="panelKicker">{t('desktopOnly.title')}</span>
      <h2>{title}</h2>
      <p>{description || t('desktopOnly.default')}</p>
    </section>
  );
}
